module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row report-template report-template-editing"
  }, [_c('div', {
    staticClass: "col-md-9 contents"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-3",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Template Name:")]), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.name),
      expression: "template.name"
    }],
    staticClass: "col-md-12 title",
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.template.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "name", $event.target.value)
      }
    }
  })]), _c('label', {
    staticClass: "col-md-3",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Template Short Name:")]), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.name_short),
      expression: "template.name_short"
    }],
    staticClass: "col-md-12 title_short",
    attrs: {
      "id": "name_short",
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.template.name_short)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "name_short", $event.target.value)
      }
    }
  })]), _c('label', {
    staticClass: "col-md-3",
    attrs: {
      "for": "tod"
    }
  }, [_vm._v("Day of Week")]), _c('div', {
    staticClass: "col-md-9"
  }, [_c('vue-multiselect', {
    attrs: {
      "value": _vm.dow,
      "options": _vm.days,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": true,
      "preserve-search": true,
      "placeholder": "Day"
    },
    on: {
      "input": _vm.setDays
    },
    scopedSlots: _vm._u([{
      key: "tag",
      fn: function(props) {
        return [_c('span', {
          staticClass: "custom__tag"
        }, [_c('span', [_vm._v(_vm._s(props.option))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props.option)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }])
  })], 1), _c('label', {
    staticClass: "col-md-3",
    attrs: {
      "for": "tod"
    }
  }, [_vm._v("Time Of Day")]), _c('div', {
    staticClass: "col-md-9"
  }, [_c('vue-multiselect', {
    attrs: {
      "value": _vm.tod,
      "options": _vm.hours,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": true,
      "preserve-search": true,
      "placeholder": "Hour"
    },
    on: {
      "input": _vm.setHours
    },
    scopedSlots: _vm._u([{
      key: "tag",
      fn: function(props) {
        return [_c('span', {
          staticClass: "custom__tag"
        }, [_c('span', [_vm._v(_vm._s(props.option))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props.option)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }])
  })], 1), _c('div', {
    staticClass: "col-md-12 field intro"
  }, [_c('label', {
    staticClass: "col-md-12",
    attrs: {
      "for": "intro"
    }
  }, [_vm._v("Intro:")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.intro),
      expression: "template.intro"
    }],
    staticClass: "form-control col-md-12",
    attrs: {
      "rows": "10",
      "placeholder": "Intro Text"
    },
    domProps: {
      "value": (_vm.template.intro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "intro", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "col-md-12 field outro"
  }, [_c('label', {
    staticClass: "col-md-12",
    attrs: {
      "for": "outro"
    }
  }, [_vm._v("Outro:")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template.close),
      expression: "template.close"
    }],
    staticClass: "form-control col-md-12",
    attrs: {
      "rows": "10",
      "placeholder": "Outro Text"
    },
    domProps: {
      "value": (_vm.template.close)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.template, "close", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-3 images"
  }, [_c('div', [_vm._v("Images:")]), _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleImagesExpanded.apply(null, arguments)
      }
    }
  }, [_vm._v("Toggle Details")])], 1), (_vm.imagesExpanded) ? _c('draggable', {
    staticClass: "col-md-9 row images",
    model: {
      value: (_vm.images),
      callback: function($$v) {
        _vm.images = $$v
      },
      expression: "images"
    }
  }, _vm._l((_vm.images), function(image) {
    return _c('div', {
      staticClass: "row image"
    }, [_c('div', {
      staticClass: "col-md-12 field"
    }, [_c('label', {
      staticClass: "col-md-2",
      attrs: {
        "for": "title"
      }
    }, [_vm._v("Title:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (image.title),
        expression: "image.title"
      }],
      staticClass: "col-md-10 title",
      attrs: {
        "id": "title",
        "type": "text",
        "placeholder": "Title"
      },
      domProps: {
        "value": (image.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(image, "title", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "col-md-12 field"
    }, [_c('label', {
      staticClass: "col-md-2",
      attrs: {
        "for": "text"
      }
    }, [_vm._v("Text:")]), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (image.text),
        expression: "image.text"
      }],
      staticClass: "form-control col-md-10 text",
      attrs: {
        "id": "text",
        "rows": "5",
        "placeholder": "Text"
      },
      domProps: {
        "value": (image.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(image, "text", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "col-md-12 field"
    }, [_c('label', {
      staticClass: "col-md-2",
      attrs: {
        "for": "url"
      }
    }, [_vm._v("URL:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (image.url),
        expression: "image.url"
      }],
      staticClass: "col-md-10 url",
      attrs: {
        "id": "url",
        "type": "text",
        "placeholder": "URL"
      },
      domProps: {
        "value": (image.url)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(image, "url", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "col-md-12 field"
    }, [_c('label', {
      staticClass: "col-md-2",
      attrs: {
        "for": "timeout"
      }
    }, [_vm._v("timeout:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (image.timeout),
        expression: "image.timeout"
      }],
      staticClass: "col-md-10 url",
      attrs: {
        "id": "delay",
        "type": "number",
        "min": "1",
        "max": "180",
        "placeholder": "Timeout"
      },
      domProps: {
        "value": (image.timeout)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(image, "timeout", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "col-md-12 field"
    }, [_c('label', {
      staticClass: "col-md-2",
      attrs: {
        "for": "width"
      }
    }, [_vm._v("width:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (image.width),
        expression: "image.width"
      }],
      staticClass: "col-md-10 url",
      attrs: {
        "id": "delay",
        "type": "number",
        "min": "1",
        "max": "180",
        "placeholder": "Width"
      },
      domProps: {
        "value": (image.width)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(image, "width", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "col-md-12 field"
    }, [_c('label', {
      staticClass: "col-md-2",
      attrs: {
        "for": "height"
      }
    }, [_vm._v("height:")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (image.height),
        expression: "image.height"
      }],
      staticClass: "col-md-10 url",
      attrs: {
        "id": "delay",
        "type": "number",
        "min": "1",
        "max": "180",
        "placeholder": "Height"
      },
      domProps: {
        "value": (image.height)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(image, "height", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "col-md-4 push-md-8 actions"
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.onDeleteImage(image)
        }
      }
    }, [_vm._v("Delete")])], 1)])
  }), 0) : _c('draggable', {
    staticClass: "col-md-9 row images",
    model: {
      value: (_vm.images),
      callback: function($$v) {
        _vm.images = $$v
      },
      expression: "images"
    }
  }, _vm._l((_vm.images), function(image) {
    return _c('div', {
      staticClass: "row image collapsed col-md-12"
    }, [_c('strong', {
      staticClass: "col-md-12"
    }, [_vm._v(_vm._s(image.title))])])
  }), 0), _c('footer', {
    staticClass: "row col-md-12"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onAddImage.apply(null, arguments)
      }
    }
  }, [_vm._v("Add Image")])], 1)], 1)]), _c('div', {
    staticClass: "col-md-3 actions"
  }, [_c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSave.apply(null, arguments)
      }
    }
  }, [_vm._v("Save")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-022e942e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report-template-form.vue
// module id = 253
// module chunks = 1